import { ThemeClass } from '@store/debugger';

export const GRID_COLUMNS: Array<number> = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
export const HOOK_ELEMENT: string = '[js-hook-development-overlay]';
export const CLASS_VISIBLE: string = 'u-hidden';
export const TOGGLE_BPDGRID__KEY: string = 'KeyQ';
export const THEME_CLASSES: ThemeClass[] = [
    't-theme-sustainable',
    't-theme-classic',
    't-theme-modern',
    't-theme-raw',
    't-theme-urban',
];
